export class User
{
	id: number;
	userId: number;
	username: string;
	password: string;
	passwordResetToken: string;
	firstName: string;
	lastName: string;
	token: string;
	userRoles: any[];
	visitorTrackingID: string;
}
